import { UserRoleType } from "./IUser";
import Organisation from "./Organisation";
import { ISelectOption } from "./Select";

export interface RoleEmailTemplate {
  id: string;
  role: UserRoleType;
  emailTemplateId: string;
}

interface EmailTemplate {
  id: string;
  templateId: string;
  label: string;
  roleEmailTemplates: RoleEmailTemplate[];
  condition?: EmailTemplateConditionType;
  organisationId: string | null;
  organisation: Organisation | null;
  createdAt: string;
  updatedAt: string;
}

export type EmailTemplateConditionType = "MEETING";
export interface EmailTemplateForm {
  templateId: string;
  label: string;
  roles: ISelectOption<UserRoleType>[];
  condition: ISelectOption<EmailTemplateConditionType>;
  organisation?: Organisation | null;
}

export const EMAIL_TEMPLATE_CONDITIONS: ISelectOption<EmailTemplateConditionType>[] =
  [{ value: "MEETING", label: "Réunion" }];

export interface EmailTemplateFormSend {
  templateId: string;
  label: string;
  roles: UserRoleType[];
  organisationId?: string | null;
  condition?: string;
}

export default EmailTemplate;
